/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfString } from '../../models/platform-api-result-of-string';
import { PlatformRevokeTokenCommand } from '../../models/platform-revoke-token-command';

export interface PostUseraccountsActionRevokeToken$Params {
      body: PlatformRevokeTokenCommand
}

export function postUseraccountsActionRevokeToken(http: HttpClient, rootUrl: string, params: PostUseraccountsActionRevokeToken$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfString>> {
  const rb = new RequestBuilder(rootUrl, postUseraccountsActionRevokeToken.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfString>;
    })
  );
}

postUseraccountsActionRevokeToken.PATH = '/api/useraccounts/action/revoke-token';
